module.exports = __webpack_public_path__ + "static/media/nptel_logo.95a12a2b.png";